import React, { Component } from 'react';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value:0
        };
    }

    render() {
      // Render nothing if the "show" prop is false
      if(!this.props.show) {
        return null;
      }

      return (
        <div id="backdrop">
          <div className="modal">
            Slide To Redeem
            <div>
            <InputRange
                maxValue={20}
                minValue={0}
                formatLabel={value => ''}
                value={this.state.value}
                onChange={value => this.setState({ value })}
                onChangeComplete={value => {
                    if(value===20){
                        console.log('completed');
                        this.setState({ value:0 })
                        this.props.onClose();
                        this.props.redeemSuccessful();
                    } else {
                        this.setState({ value:0 })
                    }
                }                
                } />
            </div>
  
            <div className="footer">
              <button class="btn" onClick={this.props.onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
  

class RewardDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isOpen: false,
            isRedeemSuccessful: false
        };
    }

    redeemSuccessful(){
        this.setState({
            isRedeemSuccessful: true
        })
    }

    componentDidMount() {
        
        const url = 'https://api.glippy.com/v1/profile';
        const that = this;

        fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-User-Email':'test@test.com',
                    'X-User-Token':'g14NHohYNLouJ6HxdYor',
                },
            })
        .then((response) => {
            return response.json();
        })
    
        .then((data) => {
            this.setState({
                data: data,
                loading: false
            })
        })
        .catch((error) => console.log(error));
    }

    toggleModal = () => {

        this.setState({
          isOpen: !this.state.isOpen
        });
      }

    render() {
        const rewardID = this.props.match.params.id;
        var classes = "discount-show";
        if(this.state.isRedeemSuccessful) {
            classes += " inactive"
        } 

        var reward = {
            active: "",
            award_level:"",
            description: "",
            id:"",
            image_bg:{
                merch_logo_url: ""
            }, 
            terms: "",
            title: ""
        };

        if (this.state.data) { //get the reward by ID
            const data = this.state.data;
            var rewards = [];

            data.merchants.forEach(element => {
                element.discounts.forEach(element => {
                    rewards.push(element);
                })
            });

            reward = rewards.find(function (reward) {
                return reward.id === parseInt(rewardID);
            })
        }

        var style={ backgroundImage: "url("+reward.image_bg.url+")"};
        var rewardRibbonClass = "ribbon"
        if(reward.award_level == "gold"){
            rewardRibbonClass = "ribbon"
        }else if(reward.award_level == "silver"){
            rewardRibbonClass = "ribbon-gray"
        }


        return (
            
            this.state.loading ? <div className="loading">loading</div> :

            <div className={classes} style={{flex: 1}}>
                    <div className="discount-splash" style={style}>
                    <div className={rewardRibbonClass}><span>{reward.award_level}</span></div>
                        <div className="discount-text-wrapper">
                            
                            <img className="discount-merchant-logo" src={reward.merch_logo_url} />
                            <div className="discount-text-bg">    
                                <span className="discount-text-large">{reward.title}</span>
                            </div>
                            {/* <div className="discount-text-bg">    
                                <span className="discount-text-large">SANDWICH</span>
                            </div> */}
                            <div className="discount-text-bg">     
                                <span className="discount-text-small">{reward.description}</span>
                            </div>
                        </div>
                        <div className="terms-bar">TERMS: {reward.terms}</div>
                    </div>
               
                <div className="redeem-wrapper" onClick={this.toggleModal}>
                    <div className="btn-redeem"> Redeem</div>
                </div>
                <div className="discount-support-message">
                {reward.merch_name} <br/>Proudly Supports
                </div>
                <div className="discount-status-card">

                    <div className="discount-status-card-org-wrapper">
                        <img className="discount-org-logo" src={this.state.data.org_logo_url}  alt="Smiley face" />
                        <div className="discount-program-wrapper">
                            <div className="discount-org-name">
                            {this.state.data.organization}
                            </div>
                            <div className="discount-program">
                            Student Reward Program
                            </div>
                        </div>
                    </div>
                    <div className="discount-status-bar">
                        <div className="discount-status-text">
                            Thank you for being a great student and achieving <span style={{ textTransform: "capitalize", fontWeight: "bolder"  }}>{this.state.data.award_level} Level</span>
                        </div>
                    </div>
                </div>

                <Modal show={this.state.isOpen}
                    onClose={this.toggleModal}
                    redeemSuccessful={this.redeemSuccessful.bind(this)}> 
                </Modal>
            </div>
        )
    }

}

export default RewardDetail;





// WEBPACK FOOTER //
// ./src/components/RewardDetail/RewardDetail.js